export const LOCAL_STORAGE = {
  memberId: 'memberId',
  token: 'token',
  location: 'location',
  email: 'email',
};

export const getToken = () => localStorage.getItem(LOCAL_STORAGE.token);
